import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthProvider } from '../../utils/auth';
import { AppRoutes } from '../../constants/routes';
import AccountTypeSwitcher from '../AccountTypeSwitcher';

/**
 * Route guard that only allows podcasters to access the route
 * Redirects other user types appropriately
 */
const PodcasterOnlyRoute = ({ children }) => {
  const { isAuthed, userType, isLoading } = useAuthProvider();
  const location = useLocation();

  // Show loading while checking auth status
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        color: 'white'
      }}>
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthed) {
    return <Navigate to={AppRoutes.LoginPage} state={{ from: location }} replace />;
  }

  // Show account type switcher for non-podcasters
  if (userType !== 'podcaster') {
    return (
      <AccountTypeSwitcher
        currentUserType={userType}
        targetUserType="podcaster"
        title="Podcaster Access Required"
        message="You're currently signed in as a different account type, but this feature requires a podcaster account to manage podcasts and episodes."
      />
    );
  }

  // Allow access for podcasters
  if (userType === 'podcaster') {
    return children;
  }

  // Fallback - redirect to login if user type is unknown
  return <Navigate to={AppRoutes.LoginPage} state={{ from: location }} replace />;
};

export default PodcasterOnlyRoute;
